import fieldData from '@/_oad_repo/mixins/fieldBuilder'

export default fieldData